import { useParams, useSearchParams } from 'react-router-dom';
import Container from '../../../../core/components/atoms/Container';
import { Breadcrumbs } from '../../../../core/components/organism/Breadcrumbs';
import { useEssayTheme } from '../../hooks/useEssayTheme';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Chip } from '../../../../core/components/atoms/Chip';
import { essayTitle } from '../../utils';
import { Fragment, useEffect } from 'react';
import { useAlternativeGetUserEssay } from '../../hooks/useSubGetEssay';
import { CorrectionImage } from '../../components/CorrectedImage';
import { Alert } from '../../../../core/components/atoms/Alert';
import BrainLoadingWrapper from '../../../../core/components/molecules/BrainLoading';
import { Input } from '../../../../core/components/atoms/Input';
import EssayWaitingPaper from '../../components/WaitingPaper';
import { format } from 'date-fns';

export function WaitingEssayPage() {
  const { slug } = useParams();
  const [ searchParams ] = useSearchParams();

  const { mutate, data, isPending } = useAlternativeGetUserEssay();
  const { data: theme, isPending: isPendingTheme } = useEssayTheme(slug || '');

  useEffect(() => {
    if (slug) {
      mutate({ slug, tryNumber: Number(searchParams.get('tryNumber')) || undefined });
    }
  }, [slug, searchParams]);

  const sizes = (size: number) => {
    if (size === 16) {
      return 'default';
    }

    if (size === 14) {
      return 'small';
    }

    return 'large';
  };

  return (
    <Container
      gap='xxl'
      direction='col'
      type='updated'
      className='xs:mb-[30px] xl:mb-[30px]'
    >
      <Breadcrumbs
        items={[
          {
            label: 'Minhas redações',
            href: '/redacoes/minhas_redacoes',
          },
          {
            label: theme?.theme || '',
            href: '#',
          },
        ]}
      />
      {isPending === true || isPendingTheme === true || !data ? <BrainLoadingWrapper /> : (
        <Fragment>
          <div className='flex flex-col gap-xxl'>
            <div className='flex flex-col gap-xs xs:w-full lg:basis-3/4'>
              <Typography size='h2' type='title'>
                {theme?.theme}
              </Typography>
              <div className='gap-sm xs:hidden lg:inline-flex'>
                {theme?.correctionType && (
                  <Chip
                    className={`shadow-level-none bg-mono-color-lighter text-mono-color-black border-none px-2`}
                  >
                    {essayTitle(theme.correctionType)}
                  </Chip>
                )}
                {theme?.webDoc && (
                  <Chip
                    className={`shadow-level-none bg-mono-color-lighter text-mono-color-black border-none px-2`}
                  >
                    AprovaDoc
                  </Chip>
                )}
                {theme?.axis && theme?.axis.main.title && (
                  <Chip
                    className={`shadow-level-none bg-mono-color-lighter text-mono-color-black border-none px-2`}
                  >
                    {theme?.axis.main.title}
                  </Chip>
                )}
              </div>
            </div>
            <Alert
              variant='warning'
              message={`
                Sua redação ainda está sendo corrigida. 
                Prazo de correção: ${format(new Date(data.limitDateToCorrection), 'dd/MM/yyyy')}
              `}
            />
            <div className='m-auto w-fit'>
              {(data.theme.correctionType === 3 || data.theme.correctionType === 7) && (
                <div className='m-auto xs:w-full lg:w-[750px] mb-8'>
                  <Input
                    placeholder='Titulo'
                    value={data.title || ""}
                    variant='sm'
                    disabled={true}
                  />
                </div>
              )}
              {!data.image ? (
                <EssayWaitingPaper
                  essayText={data?.text || ''}
                  essayTitle={data?.title || ''}
                  fontSize={sizes(data.fontSize)}
                  correction={data?.theme.correctionType || 2}
                  isLoading={isPending}
                />
              ) : (
                <CorrectionImage 
                  imageUrl={data.image} 
                  imageMap='' 
                  comments={[]} 
                />
              )}
            </div>
          </div>
        </Fragment>
      )}
    </Container>
  );
}
